var render, staticRenderFns
import script from "./direct_stores.vue?vue&type=script&lang=js"
export * from "./direct_stores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56d20277')) {
      api.createRecord('56d20277', component.options)
    } else {
      api.reload('56d20277', component.options)
    }
    
  }
}
component.options.__file = "found/views/kms_new/views/direct_stores/direct_stores.vue"
export default component.exports